import React from 'react'
import { useMediaQuery } from 'react-responsive'
import theme from '@/components/themes/mainTheme'
import Grid from '@mui/material/Grid2'
import ImageList from '@mui/material/ImageList'
import ImageListItem from '@mui/material/ImageListItem'
import Image from '@/components/image/Image'
import { useNavigate, useSearchParams } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import RegularButton from '@/components/buttons/RegularButton'
import galleryData from './galleryImages.json'

const ImageGallery: React.FC = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.values.md}px)`,
  })
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const selector = searchParams.get('selector')
  const foundImageKey = Object.keys(galleryData).find(
    (dataKey) => dataKey === selector,
  )
  return (
    <>
      <Grid
        container
        direction="row"
        columnSpacing={2}
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid size={10} textAlign="start" marginTop="20px">
          <RegularButton
            label={
              <>
                <ArrowBackIcon /> Tillbaka
              </>
            }
            onClick={() => navigate('/gallery-selector')}
          />
        </Grid>

        {!foundImageKey ? (
          <Grid size={10}>
            <h1>Inga bilder här :(</h1>
          </Grid>
        ) : (
          <>
            <Grid size={10}>
              <h1>
                {galleryData[foundImageKey as keyof typeof galleryData].header}
              </h1>
            </Grid>
            <Grid size={{ xs: 11, md: 10 }}>
              <ImageList cols={isMobile ? 1 : 4} gap={50}>
                {galleryData[
                  foundImageKey as keyof typeof galleryData
                ].images.map((image, index) => (
                  <ImageListItem key={index}>
                    <Image
                      src={`${image.path}?w=164&fit=crop&auto=format&dpr=2 2x`}
                      alt={`Bildlista ${index}`}
                      loading="lazy"
                    />
                    <p style={{ marginBottom: '0' }}>{image.description}</p>
                    <p style={{ marginTop: '0' }}>
                      <i>{image.source}</i>
                    </p>
                  </ImageListItem>
                ))}
              </ImageList>
            </Grid>
          </>
        )}
      </Grid>
    </>
  )
}

export default ImageGallery
